import dayjs from 'dayjs';
import { type TimeRangeInfo } from '@/common/utils';
import { ONE_HOUR, ONE_MINUTE, ONE_DAY } from '@/common/utils';
import { getUtcTimeNow } from '@/common/utils/time.utils';
import { returnMatchingFormat } from '@/common/utils/core/time/parse';
import { UTC_TIME_FORMAT } from '@/common/components/molecules/timeController/constants';

export const getSessionDetailTimePeriodByInterval = ({
  fromTime,
  toTime,
}: Partial<TimeRangeInfo>): TimeRangeInfo => {
  // Session Detail fromTime, toTime (min 10m)

  const toTimeDayjs = toTime ? dayjs(toTime, returnMatchingFormat(toTime)) : getUtcTimeNow();
  const fromTimeDayjs = fromTime ? dayjs(fromTime, returnMatchingFormat(fromTime)) : null;
  const intervalValue = fromTimeDayjs ? toTimeDayjs.diff(fromTimeDayjs) : ONE_MINUTE * 10;

  if (intervalValue <= ONE_MINUTE * 10) {
    // 1h
    return {
      fromTime: toTimeDayjs.subtract(10, 'minute').format(UTC_TIME_FORMAT),
      toTime: toTimeDayjs.format(UTC_TIME_FORMAT),
    };
  }
  return {
    fromTime: toTimeDayjs.subtract(intervalValue).format(UTC_TIME_FORMAT),
    toTime: toTimeDayjs.format(UTC_TIME_FORMAT),
  };
};

export const getSqlDetailTimePeriodByInterval = ({
  fromTime,
  toTime,
}: Partial<TimeRangeInfo>): TimeRangeInfo => {
  // SQL List > Time Period Indicator value to SQL Detail fromTime, toTime

  const toTimeDayjs = toTime ? dayjs(toTime, returnMatchingFormat(toTime)) : getUtcTimeNow();
  const fromTimeDayjs = fromTime ? dayjs(fromTime, returnMatchingFormat(fromTime)) : null;
  const intervalValue = fromTimeDayjs ? toTimeDayjs.diff(fromTimeDayjs) : ONE_HOUR;

  if (intervalValue >= ONE_DAY * 30) {
    // 30d, API limit
    return {
      fromTime: toTimeDayjs.subtract(30, 'day').format(UTC_TIME_FORMAT),
      toTime: toTimeDayjs.format(UTC_TIME_FORMAT),
    };
  }
  if (intervalValue <= ONE_HOUR) {
    // 1h
    return {
      fromTime: toTimeDayjs.subtract(1, 'hour').format(UTC_TIME_FORMAT),
      toTime: toTimeDayjs.format(UTC_TIME_FORMAT),
    };
  }
  return {
    fromTime: toTimeDayjs.subtract(intervalValue).format(UTC_TIME_FORMAT),
    toTime: toTimeDayjs.format(UTC_TIME_FORMAT),
  };
};
